import { TemplatePage } from './types';

const greetingPage: TemplatePage = {
  header: {
    color: '#F3F3F1',
    icon: 'images/video-templates/greeting.jpg',
    title: 'Greeting Video Templates',
    title_meta: '50+ Free Customizable Greetings Video Templates',
    description_meta:
      'Make your closed ones feel very special with Wave.video’s collection of customizable greeting video templates.',
    description:
      'Make your closed ones feel very special with this collection of customizable greeting video templates. ' +
      'Create heart-warming video greeting cards and share them with people you care about no matter where they ' +
      'are in the world.'
  },
  footer: {
    category: 'Greeting',
    description:
      'With Wave.video’s wide range of greeting video templates, you can create stunning videos for your social ' +
      'media, blog, website, or email newsletter in a matter of minutes. All the templates are free and easy to ' +
      'personalize to get your message across.'
  },
  content: [
    {
      type: 'templates',
      title: 'Greeting Videos',
      search: { category: '/Use Cases/Greetings' }
    },
    {
      type: 'stocks',
      title: 'greeting',
      search: { name: 'greeting' }
    },
    { type: 'calendar' }
  ]
};

export default greetingPage;
